import { useEffect } from "react"

import useCoachOnboardingStore, {
  isCoachFocus,
} from "./useCoachOnboardingStore"
import WelcomeContent from "./WelcomeContent"
import { useCoachFunnelEntryAttribution } from "../../hooks/useCoachFunnelEntryAttribution"
import useDocumentTitle from "../../hooks/useDocumentTitle"
import { useQuestionnairesQuery } from "../../networking/queries"
import { useRouter } from "../../util/router"
import { sessionManager } from "../../util/storage"

export default function CoachWelcomePage() {
  useDocumentTitle("Joon - Welcome")
  const router = useRouter()
  // This is called here to preload/cache questionnaires for survey step
  useQuestionnairesQuery()
  const setFocus = useCoachOnboardingStore((state) => state.setFocus)

  // Fires CONTACT pixels (FB/TikTok/Pinterest), Amplitude SHOW_WELCOME,
  // and Google Ads START_QUIZ — with session-local dedup so it won't
  // double-fire if the parent later hits /coach-onboarding from here.
  useCoachFunnelEntryAttribution("welcome")

  // Capture the branching-CTA entry-point tag from jooncoach.com.
  // The landing page's CTAs deep-link here with `?focus=`; we persist
  // it once for the rest of the funnel + analytics joins.
  useEffect(() => {
    const incoming = router.query.focus
    if (isCoachFocus(incoming)) setFocus(incoming)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query.focus])

  useEffect(() => {
    if (sessionManager.getRefreshToken()) router.push("/coaching")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <WelcomeContent />
}
